﻿import type { ReactNode } from 'react';

export const AREA_SELECTION_PATH = 'areaselection';
export const SHORTCUT_RESOLVER_PATH = 'shortcutresolver';

// Konstanten zum eindeutigen und type-sicheren Identifizieren von Routen.
// Aktuell gibt es nur ein Szenario, in welchem die Cart-Route identifiziert werden muss. 
// In Zukunft könnte es hier aber weitere IDs geben ...
export const ROUTE_IDS = {
  CART: 'CART'
} as const;

export type RouteId = (typeof ROUTE_IDS)[keyof typeof ROUTE_IDS];

export type RouteHandle = {
  routeId?: RouteId;
  subNavigationItems?: () => ReactNode;
};